export function patientRoute(patientGuid: string | null | undefined, segment: string): string {
  if (patientGuid) {
    return `/features/patient/${patientGuid}/${segment}`;
  }

  return `/patient/${segment}`;
}

export function providerRoute(providerGuid: string | null | undefined, segment: string): string {
  if (!providerGuid) {
    return '/auth/register';
  }

  return `/features/provider/${providerGuid}/${segment}`;
}
